import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "project-page__header" }
const _hoisted_2 = { class: "project-page__header-person" }
const _hoisted_3 = { class: "project-page__header-person-name" }
const _hoisted_4 = { class: "project-page__header-person-date" }
const _hoisted_5 = { class: "project-page__header-options" }
const _hoisted_6 = {
  key: 2,
  class: "project-page__header-options-tags"
}
const _hoisted_7 = { class: "project-page__header-options-tags-item-name" }
const _hoisted_8 = {
  key: 1,
  class: "project-page__header-permition"
}
const _hoisted_9 = { class: "project-page__header-permition-label" }
const _hoisted_10 = { class: "project-page__project" }
const _hoisted_11 = { class: "project-page__project-icon-block" }
const _hoisted_12 = { class: "project-page__project-title" }
const _hoisted_13 = {
  key: 0,
  class: "project-page__project-name"
}
const _hoisted_14 = { class: "project-page__stage" }
const _hoisted_15 = { class: "project-page__project-icon-block" }
const _hoisted_16 = { class: "project-page__stage-title" }
const _hoisted_17 = { class: "project-page__direction" }
const _hoisted_18 = { class: "project-page__direction-header project-page__direction-header--finance" }
const _hoisted_19 = { class: "project-page__direction-header-left" }
const _hoisted_20 = { class: "project-page__direction-header-title" }
const _hoisted_21 = {
  key: 0,
  class: "project-page__direction-header-right"
}
const _hoisted_22 = {
  key: 0,
  class: "project-page__direction-body"
}
const _hoisted_23 = { class: "project-page__direction" }
const _hoisted_24 = { class: "project-page__direction-header" }
const _hoisted_25 = { class: "project-page__direction-header-left" }
const _hoisted_26 = { class: "project-page__direction-header-title" }
const _hoisted_27 = { class: "project-page__direction-uc-left" }
const _hoisted_28 = { class: "project-page__direction-uc-left-count" }
const _hoisted_29 = { class: "project-page__direction-uc-left-name" }
const _hoisted_30 = {
  key: 0,
  class: "project-page__direction-uc-left-address"
}
const _hoisted_31 = {
  key: 3,
  class: "project-page__direction-uc-left-roles"
}
const _hoisted_32 = { class: "project-page__direction-uc-left-roles-item-name" }
const _hoisted_33 = { class: "project-page__direction" }
const _hoisted_34 = { class: "project-page__direction-header" }
const _hoisted_35 = { class: "project-page__direction-header-left" }
const _hoisted_36 = { class: "project-page__direction-header-title" }
const _hoisted_37 = {
  key: 0,
  class: /*@__PURE__*/_normalizeClass({
					'project-page__direction-body': true,
					'project-page__direction-body--aw': true
				})
}
const _hoisted_38 = { class: "project-page__direction-aw-left" }
const _hoisted_39 = { class: "project-page__direction-aw-left-count" }
const _hoisted_40 = {
  key: 2,
  class: "project-page__direction-aw-left-roles"
}
const _hoisted_41 = { class: "project-page__direction-aw-left-roles-item-name" }
const _hoisted_42 = {
  key: 2,
  class: "project-page__direction"
}
const _hoisted_43 = { class: "project-page__direction-header" }
const _hoisted_44 = { class: "project-page__direction-header-left" }
const _hoisted_45 = { class: "project-page__direction-header-title" }
const _hoisted_46 = {
  key: 0,
  class: "project-page__direction-body"
}
const _hoisted_47 = {
  class: "project-page__direction",
  style: {"height":"100%","min-height":"123px"}
}
const _hoisted_48 = {
  key: 0,
  class: "project-page",
  style: {"justify-content":"center","margin-top":"8px","max-height":"378px"}
}
const _hoisted_49 = { class: "project-page__direction" }
const _hoisted_50 = { class: "project-page__direction-permition" }
const _hoisted_51 = { class: "project-page__direction-permition-label" }

import {
	useRoute,
	useRouter
} from "vue-router";
import {
	computed,
	nextTick,
	onBeforeUnmount,
	onMounted,
	ref,
	watch
} from "vue";
import AppIcon from "@/components/ui-kit/icon/AppIcon.vue";
import AppTooltip from "@/components/ui-kit/tooltip/AppTooltip.vue";
import AppLoader from "@/components/common/AppLoader.vue";
import FileBlock from "@/components/main/project-block-page/file-block/FileBlock.vue";
import AppResizableDropdown from "@/components/ui-kit/dropdown/AppResizableDropdown.vue";
import AppSelect from "@/components/ui-kit/select/AppSelect.vue";
import ProjectAddClientDropdown from "@/components/main/project-block-page/dropdowns/ProjectAddClientDropdown.vue";
import ProjectAddWorkerDropdown from "@/components/main/project-block-page/dropdowns/ProjectAddWorkerDropdown.vue";
import ProjectAddRoleDropdown from "@/components/main/project-block-page/dropdowns/ProjectAddRoleDropdown.vue";
import DeleteProjectConfirmDropdown from "@/components/main/project-block-page/dropdowns/DeleteProjectConfirmDropdown.vue";
import ProjectInfoModal from "@/components/main/project-block-page/modals/ProjectInfoModal.vue";
import ProjectFinanceSection from "@/components/main/project-block-page/finance/ProjectFinanceSection.vue";
import ProjectFinanceSummary from "@/components/main/project-block-page/finance/ProjectFinanceSummary.vue";
import ParametersSection from "@/components/main/shared/ParametersSection.vue";
import { V2ParameterAttachmentType } from "@/models/etc/parameter-types";
import StageBusinessLogicModal from "@/components/main/project-block-page/modals/StageBusinessLogicModal.vue";
import ProjectClientsExpandModal from "@/components/main/project-block-page/modals/ProjectClientsExpandModal.vue";
import ProjectFinanceExpandModal from "@/components/main/project-block-page/modals/ProjectFinanceExpandModal.vue";
import { useOverflowDetection } from "@/composables/useOverflowDetection";
import AppScrollTopButton from "@/components/ui-kit/button/AppScrollTopButton.vue";
import { useScrollTopButton } from "@/composables/useScrollTopButton";
import AppTagSelector from "@/components/ui-kit/tag-selector/AppTagSelector.vue";
import FileInput from "@/components/file/FileInput.vue";
import { projectPageStore } from "@/store/project-page";
import { favouritesStore } from "@/store/favourites";
import { TagEntityType } from "@/models/etc/types";
import { TagWithFrequency } from "@/models/interfaces/tags/tag-models";
import moment from "moment/moment";
import { workerStore } from "@/store/worker";
import { buildAbsoluteClientUrl } from "@/utils/urlHelpers";
import { copyTextToClipboard } from "@/utils/clipboard";
import { i18n } from "@/i18n";

const SHARE_TOOLTIP_KEY = 'ui_share'
const SHARE_COPIED_KEY = 'link_copied_to_clipboard'
const SHARE_COPIED_DELAY = 3000


export default /*@__PURE__*/_defineComponent({
  __name: 'ProjectBlockPage',
  setup(__props) {

const projectStore = projectPageStore()
const favourStore = favouritesStore()
const workerStorage = workerStore();

const route = useRoute()
const router = useRouter()

const $projectInfoModal = ref<InstanceType<typeof ProjectInfoModal> | null>(null)
const $stageBusinessLogicModal = ref<InstanceType<typeof StageBusinessLogicModal> | null>(null)
const $deleteProject = ref<InstanceType<typeof AppResizableDropdown> | null>(null)
const $projectNameInput = ref<InstanceType<typeof FileInput> | null>(null)
const $stageAccessTooltip = ref<typeof AppTooltip | null>(null)
const $addTag = ref<typeof AppResizableDropdown | null>(null)
const $addClient = ref<typeof AppResizableDropdown | null>(null)
const $addWorker = ref<typeof AppResizableDropdown | null>(null)

const isProjectNameEdited = ref(false)
const editedProjectName = ref("")

// Меню добавления финансов открывается из "+" в шапке блока; сам раздел рендерится телом блока
const financeAddOpen = ref(false)
const financeAddAnchor = ref<HTMLElement | null>(null)
// Меню добавления параметра открывается из "+" в шапке блока «Параметры»
const parametersAddOpen = ref(false)
const parametersAddAnchor = ref<HTMLElement | null>(null)
const $addWorkerRoles = ref<Record<number, any>>({})
const $addClientRoles = ref<Record<number, any>>({})

const isProjectLoading = computed(() => projectStore.projectLoading)
const isFavouritesLoading = computed(() => favourStore.isFavouritesLoading)
const projectId = computed(() => parseInt(route.query.id as string))
const project = computed(() => projectStore.openedProject)

const $projectPage = ref<HTMLElement | null>(null)
const { isScrollTopEnabled, scrollToTop } = useScrollTopButton(
	$projectPage,
	'.project-page__header',
	() => project.value?.Id
)

const isAdmin= workerStorage.workerProfile?.IsAdmin;

const hasAnyRestrictedAccess = computed(() => {
  const p = projectStore.project;
  if (!p) return false;

  if (isAdmin) return false;

  return (
    p.AccessLevel === 0 ||
    p.NameAccess === 0 ||
    p.StageAccess === 0 ||
    p.FinanceAccess === 0 ||
    p.AttachedClientsAccess === 0 ||
    p.AttackedWorkersAccess === 0 ||
    p.ParameterAccess === 0 ||
    p.FileAccess === 0 ||
    p.DeleteAccess === 0
  );
});

// --- Раскрытие блока «Клиенты» на весь экран (модалка) ---
// Стрелка показывается только когда тело блока переполнено и появился скролл.
const $clientsBody = ref<HTMLElement | null>(null)
const $clientsModal = ref<InstanceType<typeof ProjectClientsExpandModal> | null>(null)

const { isOverflowing: isClientsOverflowing } = useOverflowDetection(
	$clientsBody,
	() => project.value?.AttachedClients?.length ?? 0,
)

// --- Раскрытие блока «Финансы» на весь экран (модалка) ---
// Скролл-контейнер тут не обёртка, а корень самой секции, поэтому элемент берём из инстанса компонента.
const $financeSection = ref<InstanceType<typeof ProjectFinanceSection> | null>(null)
const $financeBody = ref<HTMLElement | null>(null)
const $financeModal = ref<InstanceType<typeof ProjectFinanceExpandModal> | null>(null)
watch($financeSection, (section) => {
	$financeBody.value = (section?.$el as HTMLElement) ?? null
}, { immediate: true })

const { isOverflowing: isFinanceOverflowing } = useOverflowDetection(
	$financeBody,
	() => (project.value?.Bills?.length ?? 0)
		+ (project.value?.StorageItemExpenditureMovements?.length ?? 0),
)

const fetchProject = async () => {
	await projectStore.getProject(projectId.value)
}

const toggleFavourite = async () => {
	try {
		if (!isFavouritesLoading.value) {
			if (!project.value?.Favorite) {
				await favourStore.addFavourites(projectId.value, 1)
			} else {
				await favourStore.removeFavourites(projectId.value, 1)
			}
			projectStore.updateCurrentProjectFavouriteState(!project.value?.Favorite)
		}
	} catch (error) {
		console.error(error)
	}
}

const $shareTooltip = ref<typeof AppTooltip | null>(null)

const shareTooltipKey = ref(SHARE_TOOLTIP_KEY)
const shareTooltipText = computed(() => String(i18n.global.t(shareTooltipKey.value)))

let shareTooltipTimer: ReturnType<typeof setTimeout> | null = null

const onCopyProjectRoute = async () => {
	if (Number.isNaN(projectId.value)) {
		return
	}

	const copied = await copyTextToClipboard(
		buildAbsoluteClientUrl(`main?page=project&id=${projectId.value}`)
	)
	if (!copied) {
		return
	}

	if (shareTooltipTimer) {
		clearTimeout(shareTooltipTimer)
	}
	shareTooltipKey.value = SHARE_COPIED_KEY
	$shareTooltip.value?.showByClick()
	shareTooltipTimer = setTimeout(() => {
		shareTooltipKey.value = SHARE_TOOLTIP_KEY
		shareTooltipTimer = null
	}, SHARE_COPIED_DELAY)
}

onBeforeUnmount(() => {
	if (shareTooltipTimer) {
		clearTimeout(shareTooltipTimer)
	}
})

const getCreatedDate = (date: string | Date) => moment(date).format("DD.MM.YYYY");

const editProjectName = () => {
	editedProjectName.value = project.value?.Name ?? ""
	isProjectNameEdited.value = true
	nextTick(() => $projectNameInput.value?.focus())
}

const saveProjectName = async () => {
	isProjectNameEdited.value = false
	const trimmed = editedProjectName.value.trim()
	if (!trimmed || trimmed === project.value?.Name) return

	try {
		await projectStore.renameCurrentProject(trimmed)
	} catch (error) {
		console.error(error)
	}
}

const openProjectInfoModal = () => {
	$projectInfoModal.value?.onOpen(projectId.value, (project.value?.Tags ?? []) as any)
}

const openStageBusinessLogicModal = () => {
	if (project.value?.StageAccess === 0) return
	if (project.value?.StageId == null) return
	$stageBusinessLogicModal.value?.onOpen(project.value.StageId)
}

const stageItems = computed(() => {
	const items = (project.value?.Stages ?? []).map((s: any) => ({
		id: s.Id,
		label: s.Name,
		disabled: s.IsAvailable === false || s.IsDisabled === true,
	}))
	return [
		...items.filter(i => !i.disabled),
		...items.filter(i => i.disabled),
	]
})

const onSelectStage = async (value: string | number | (string | number)[] | null) => {
	if (project.value?.StageAccess !== 2) return
	if (value == null || Array.isArray(value)) return

	const stageId = Number(value)
	if (stageId === project.value?.StageId) return

	try {
		await projectStore.changeProjectStage(stageId)
	} catch (e) {
		console.error(e)
	}
}

const onStageSelectClick = () => {
	if (project.value?.StageAccess === 1) {
		$stageAccessTooltip.value?.showByClick()
	}
}

const projectTagsModel = computed<TagWithFrequency[]>(
	() => (project.value?.Tags ?? []) as unknown as TagWithFrequency[]
)

const onSelectorChange = async (nextTags: TagWithFrequency[]) => {
	const prevIds = new Set((project.value?.Tags ?? []).map((t: any) => t.Id))
	const nextIds = new Set(nextTags.map(t => t.Id))

	const added = nextTags.filter(t => !prevIds.has(t.Id))
	const removedIds = [...prevIds].filter(id => !nextIds.has(id))

	try {
		for (const tag of added) await projectStore.attachTagToProject({ Name: tag.Name })
		for (const id of removedIds) await projectStore.detachTagFromProject(id as number)
	} catch (e) {
		console.error(e)
	}
}

const onCreateTag = async (name: string) => {
	try {
		await projectStore.attachTagToProject({ Name: name })
	} catch (e) {
		console.error(e)
	}
}

const onDetachTag = async (tagId: number) => {
	try {
		await projectStore.detachTagFromProject(tagId)
	} catch (e) {
		console.error(e)
	}
}

const closeAddClientDropdown = () => {
	$addClient.value?.close()
}

const onDetachClient = async (id: number) => {
	try {
		await projectStore.detachClientFromProject(id)
	} catch (e) {
		console.error(e)
	}
}

const closeAddWorkerDropdown = () => {
	$addWorker.value?.close()
}

const onDetachWorker = async (id: number) => {
	try {
		await projectStore.detachWorkerFromProject(id)
	} catch (e) {
		console.error(e)
	}
}

const closeAddWorkerRoleDropdown = (awId: number) => {
	$addWorkerRoles.value[awId]?.close()
}

const closeAddClientRoleDropdown = (acId: number) => {
	$addClientRoles.value[acId]?.close()
}

const onDetachWorkerRole = async (workerId: number, roleId: number) => {
	try {
		await projectStore.detachRoleFromWorker(workerId, roleId)
	} catch (e) {
		console.error(e)
	}
}

const onDetachClientRole = async (clientId: number, roleId: number) => {
	try {
		await projectStore.detachRoleFromClient(clientId, roleId)
	} catch (e) {
		console.error(e)
	}
}

const onConfirmDelete = async () => {
	if (isProjectLoading.value) return
	try {
		await projectStore.deleteProject()
		await router.push({
			path: '/',
			query: {
				page: 'chat',
				mode: 'list',
			},
		})
	} catch (error) {
		console.error(error)
		$deleteProject.value?.close()
	}
}

watch(
	() => route.query.id,
	async (newVal, oldVal) => {
		if (newVal !== oldVal) {
			await fetchProject()
		}
	}
)

onMounted(async () => {
	await fetchProject()
})

const loaderStyle = computed(() => ({
	'background-color': 'rgba(255, 255, 255, 0.5)'
}))

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: "project-page",
      ref_key: "$projectPage",
      ref: $projectPage
    }, [
      (isProjectLoading.value)
        ? (_openBlock(), _createBlock(AppLoader, {
            key: 0,
            style: _normalizeStyle(loaderStyle.value)
          }, null, 8, ["style"]))
        : _createCommentVNode("", true),
      _createVNode(AppScrollTopButton, {
        class: "project-page__scroll-top",
        enabled: _unref(isScrollTopEnabled),
        onOnClick: _unref(scrollToTop)
      }, null, 8, ["enabled", "onOnClick"]),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, _toDisplayString(project.value?.Creator?.Name || _ctx.$t('user_label')), 1),
          _createElementVNode("div", _hoisted_4, _toDisplayString(project.value ? getCreatedDate(project.value.CreateTime) : ''), 1),
          (project.value?.CanBeDeleted && _unref(projectStore).project?.DeleteAccess!==0)
            ? (_openBlock(), _createBlock(AppResizableDropdown, {
                key: 0,
                ref_key: "$deleteProject",
                ref: $deleteProject,
                position: "right",
                "centered-on-mobile": "",
                "close-by-click-outside": true,
                name: "$deleteProject"
              }, {
                activator: _withCtx(() => [
                  _createVNode(AppTooltip, {
                    text: _ctx.$t('remove')
                  }, {
                    activator: _withCtx(() => [
                      _createVNode(AppIcon, {
                        class: "project-page__header-person-icon",
                        name: "delete-outline",
                        width: "18px",
                        color: "#979797",
                        "hover-color": "#BA4C4C",
                        cursor: "pointer"
                      })
                    ]),
                    _: 1
                  }, 8, ["text"])
                ]),
                default: _withCtx(() => [
                  _createVNode(DeleteProjectConfirmDropdown, {
                    loading: isProjectLoading.value,
                    onCancel: _cache[0] || (_cache[0] = ($event: any) => ($deleteProject.value?.close())),
                    onConfirm: onConfirmDelete
                  }, null, 8, ["loading"])
                ]),
                _: 1
              }, 512))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(AppTooltip, {
            text: _ctx.$t(project.value?.Favorite ? 'favourite_remove' : 'add_to_favorites')
          }, {
            activator: _withCtx(() => [
              _createVNode(AppIcon, {
                class: "project-page__header-options-icon",
                name: "favourite",
                width: "18px",
                color: project.value?.Favorite ? '#D05A4F' : '#979797',
                "hover-color": project.value?.Favorite ? '#979797' : '#D05A4F',
                cursor: "pointer",
                onClick: toggleFavourite
              }, null, 8, ["color", "hover-color"])
            ]),
            _: 1
          }, 8, ["text"]),
          _createVNode(AppTooltip, {
            ref_key: "$shareTooltip",
            ref: $shareTooltip,
            text: shareTooltipText.value
          }, {
            activator: _withCtx(() => [
              _createVNode(AppIcon, {
                class: "project-page__header-options-icon",
                style: { marginTop: '1px' },
                name: "share",
                width: "18px",
                color: "#979797",
                "hover-color": "#499259",
                cursor: "pointer",
                onClick: onCopyProjectRoute
              })
            ]),
            _: 1
          }, 8, ["text"]),
          (_unref(projectStore).project?.AccessLevel!==0)
            ? (_openBlock(), _createBlock(AppResizableDropdown, {
                key: 0,
                ref_key: "$addTag",
                ref: $addTag,
                position: "right",
                "close-by-click-outside": true,
                "max-width": 640,
                "max-height": 460,
                "mobile-title": _ctx.$t('choose_tags'),
                name: "$addTagProjectPage"
              }, {
                activator: _withCtx(() => [
                  _createVNode(AppTooltip, {
                    text: _ctx.$t('file_add_tag')
                  }, {
                    activator: _withCtx(() => [
                      _createVNode(AppIcon, {
                        class: "project-page__header-options-icon",
                        name: "hash",
                        width: "18px",
                        color: "#979797",
                        "hover-color": "#499259",
                        cursor: "pointer"
                      })
                    ]),
                    _: 1
                  }, 8, ["text"])
                ]),
                default: _withCtx(() => [
                  _createVNode(AppTagSelector, {
                    "model-value": projectTagsModel.value,
                    "entity-type": _unref(TagEntityType).Project,
                    mode: "select",
                    "allow-create": "",
                    "onUpdate:modelValue": onSelectorChange,
                    onCreateTag: onCreateTag,
                    onClose: _cache[1] || (_cache[1] = ($event: any) => ($addTag.value?.close()))
                  }, null, 8, ["model-value", "entity-type"])
                ]),
                _: 1
              }, 8, ["mobile-title"]))
            : (_openBlock(), _createBlock(AppIcon, {
                key: 1,
                class: "project-page__header-options-icon",
                name: "hash",
                width: "18px",
                color: "#D2D2D2"
              })),
          (project.value?.Tags?.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(project.value.Tags, (tag) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: tag.Id,
                    class: "project-page__header-options-tags-item"
                  }, [
                    _createElementVNode("div", _hoisted_7, _toDisplayString(tag.Name.toLowerCase()), 1),
                    (_unref(projectStore).project?.AccessLevel!==0)
                      ? (_openBlock(), _createBlock(AppTooltip, {
                          key: 0,
                          text: _ctx.$t('ui_tag_detach')
                        }, {
                          activator: _withCtx(() => [
                            _createVNode(AppIcon, {
                              class: "project-page__direction-aw-left-icon",
                              style: { marginTop: '-2px' },
                              name: "close-bold",
                              width: "12px",
                              color: "#D2D2D2",
                              "hover-color": "#BA4C4C",
                              cursor: "pointer",
                              onClick: ($event: any) => (onDetachTag(tag.Id))
                            }, null, 8, ["onClick"])
                          ]),
                          _: 2
                        }, 1032, ["text"]))
                      : _createCommentVNode("", true)
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      (hasAnyRestrictedAccess.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createVNode(AppIcon, {
              class: "project-page__header-permition-icon",
              name: "invalid",
              width: "16px",
              color: "#979797"
            }),
            _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$t('project_limited_access')), 1)
          ]))
        : _createCommentVNode("", true),
      _cache[9] || (_cache[9] = _createElementVNode("div", { class: "project-page__divider" }, null, -1)),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          (_unref(projectStore).project?.AccessLevel==2 || _unref(projectStore).project?.AccessLevel==1)
            ? (_openBlock(), _createBlock(AppTooltip, {
                key: 0,
                text: _ctx.$t('info')
              }, {
                activator: _withCtx(() => [
                  _createVNode(AppIcon, {
                    class: "project-page__project-icon",
                    style: { marginTop: '-2px' },
                    name: "info-circle-outline",
                    width: "18px",
                    color: "#979797",
                    "hover-color": "#499259",
                    cursor: "pointer",
                    onClick: openProjectInfoModal
                  })
                ]),
                _: 1
              }, 8, ["text"]))
            : (_openBlock(), _createBlock(AppIcon, {
                key: 1,
                class: "project-page__project-icon",
                style: { marginTop: '-2px' },
                name: "info-circle-outline",
                width: "18px",
                color: "#D2D2D2"
              }))
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createTextVNode(_toDisplayString(_ctx.$t('project_label')) + _toDisplayString(_unref(projectStore).project?.NameAccess!==0 ? ':' : '') + " ", 1),
          (isProjectNameEdited.value)
            ? (_openBlock(), _createBlock(FileInput, {
                key: 0,
                ref_key: "$projectNameInput",
                ref: $projectNameInput,
                modelValue: editedProjectName.value,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((editedProjectName).value = $event)),
                onBlur: saveProjectName
              }, null, 8, ["modelValue"]))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                (_unref(projectStore).project?.NameAccess!==0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(project.value?.Name || ''), 1))
                  : _createCommentVNode("", true),
                (_unref(projectStore).project?.NameAccess==2)
                  ? (_openBlock(), _createBlock(AppTooltip, {
                      key: 1,
                      class: "project-page__project-edit",
                      text: _ctx.$t('edit_label')
                    }, {
                      activator: _withCtx(() => [
                        _createVNode(AppIcon, {
                          class: "project-page__project-icon",
                          style: { marginTop: '-2px' },
                          name: "edit-pencil",
                          width: "18px",
                          color: "#979797",
                          "hover-color": "#499259",
                          cursor: "pointer",
                          onClick: editProjectName
                        })
                      ]),
                      _: 1
                    }, 8, ["text"]))
                  : _createCommentVNode("", true)
              ], 64))
        ])
      ]),
      _cache[10] || (_cache[10] = _createElementVNode("div", { class: "project-page__divider" }, null, -1)),
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("div", _hoisted_15, [
          (_unref(projectStore).project?.StageAccess !== 0)
            ? (_openBlock(), _createBlock(AppTooltip, {
                key: 0,
                text: _ctx.$t('stage_business_logic')
              }, {
                activator: _withCtx(() => [
                  _createVNode(AppIcon, {
                    class: "project-page__project-icon",
                    style: { marginTop: '-2px' },
                    name: "info-circle-outline",
                    width: "18px",
                    color: "#979797",
                    "hover-color": "#499259",
                    cursor: "pointer",
                    onClick: openStageBusinessLogicModal
                  })
                ]),
                _: 1
              }, 8, ["text"]))
            : (_openBlock(), _createBlock(AppIcon, {
                key: 1,
                class: "project-page__project-icon",
                style: { marginTop: '-2px' },
                name: "info-circle-outline",
                width: "18px",
                color: "#D2D2D2"
              }))
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createTextVNode(_toDisplayString(_ctx.$t('stage_label')) + _toDisplayString(_unref(projectStore).project?.StageAccess!==0 ? ':' : '') + " ", 1),
          (_unref(projectStore).project?.StageAccess !== 0)
            ? (_openBlock(), _createBlock(AppTooltip, {
                key: 0,
                ref_key: "$stageAccessTooltip",
                ref: $stageAccessTooltip,
                class: "project-page__stage-select-tooltip",
                text: _ctx.$t('access_rights_restricted'),
                "anchor-align": "start",
                "show-by-activator-click": "",
                "close-on-activator-mouse-leave": ""
              }, {
                activator: _withCtx(() => [
                  _createVNode(AppSelect, {
                    class: "project-page__stage-select",
                    "model-value": project.value?.StageId ?? null,
                    items: stageItems.value,
                    placeholder: "—",
                    disabled: project.value?.StageAccess !== 2,
                    "onUpdate:modelValue": onSelectStage,
                    onClick: onStageSelectClick
                  }, null, 8, ["model-value", "items", "disabled"])
                ]),
                _: 1
              }, 8, ["text"]))
            : _createCommentVNode("", true)
        ])
      ]),
      _cache[11] || (_cache[11] = _createElementVNode("div", { class: "project-page__divider" }, null, -1)),
      _createElementVNode("div", _hoisted_17, [
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("div", _hoisted_19, [
            (_unref(projectStore).project?.FinanceAccess==2)
              ? (_openBlock(), _createBlock(AppTooltip, {
                  key: 0,
                  text: _ctx.$t('ui_add')
                }, {
                  activator: _withCtx(() => [
                    _createElementVNode("span", {
                      ref_key: "financeAddAnchor",
                      ref: financeAddAnchor,
                      class: "project-page__direction-header-add-anchor",
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (financeAddOpen.value = true))
                    }, [
                      _createVNode(AppIcon, {
                        class: "project-page__direction-header-icon",
                        name: "plus",
                        width: "15px",
                        color: "#979797",
                        "hover-color": "#499259",
                        cursor: "pointer"
                      })
                    ], 512)
                  ]),
                  _: 1
                }, 8, ["text"]))
              : (_openBlock(), _createBlock(AppIcon, {
                  key: 1,
                  class: "project-page__direction-header-icon",
                  name: "plus",
                  width: "15px",
                  color: "#D2D2D2"
                })),
            _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.$t('finances')), 1),
            (_unref(projectStore).project?.FinanceAccess !== 0 && _unref(isFinanceOverflowing))
              ? (_openBlock(), _createBlock(AppTooltip, {
                  key: 2,
                  text: _ctx.$t('ui_fullscreen')
                }, {
                  activator: _withCtx(() => [
                    _createVNode(AppIcon, {
                      class: "project-page__direction-header-icon",
                      name: "arrow-expand",
                      width: "18px",
                      color: "#979797",
                      "hover-color": "#499259",
                      cursor: "pointer",
                      onClick: _cache[4] || (_cache[4] = ($event: any) => ($financeModal.value?.onOpen()))
                    })
                  ]),
                  _: 1
                }, 8, ["text"]))
              : _createCommentVNode("", true)
          ]),
          (project.value && _unref(projectStore).project?.FinanceAccess !== 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                _createVNode(ProjectFinanceSummary, { project: project.value }, null, 8, ["project"])
              ]))
            : _createCommentVNode("", true)
        ]),
        (project.value && _unref(projectStore).project?.FinanceAccess !== 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
              _createVNode(ProjectFinanceSection, {
                ref_key: "$financeSection",
                ref: $financeSection,
                project: _unref(projectStore).project,
                "project-id": projectId.value,
                "finance-access": _unref(projectStore).project?.FinanceAccess,
                "add-menu-target": financeAddAnchor.value,
                "add-menu-open": financeAddOpen.value,
                "onUpdate:addMenuOpen": _cache[5] || (_cache[5] = ($event: any) => ((financeAddOpen).value = $event)),
                onChanged: fetchProject
              }, null, 8, ["project", "project-id", "finance-access", "add-menu-target", "add-menu-open"])
            ]))
          : _createCommentVNode("", true)
      ]),
      _cache[12] || (_cache[12] = _createElementVNode("div", { class: "project-page__divider" }, null, -1)),
      _createElementVNode("div", _hoisted_23, [
        _createElementVNode("div", _hoisted_24, [
          _createElementVNode("div", _hoisted_25, [
            (_unref(projectStore).project?.AttachedClientsAccess==2)
              ? (_openBlock(), _createBlock(AppResizableDropdown, {
                  key: 0,
                  position: "right",
                  resizable: "",
                  "initial-width": 400,
                  "initial-height": 450,
                  "min-width": 400,
                  "max-width": 800,
                  "min-height": 450,
                  "max-height": 900,
                  "mobile-title": _ctx.$t('choose_clients'),
                  ref_key: "$addClient",
                  ref: $addClient,
                  name: "$addClient"
                }, {
                  activator: _withCtx(() => [
                    _createVNode(AppTooltip, {
                      text: _ctx.$t('ui_add')
                    }, {
                      activator: _withCtx(() => [
                        _createVNode(AppIcon, {
                          class: "project-page__direction-header-icon",
                          name: "plus",
                          width: "15px",
                          color: "#979797",
                          "hover-color": "#499259",
                          cursor: "pointer"
                        })
                      ]),
                      _: 1
                    }, 8, ["text"])
                  ]),
                  default: _withCtx(() => [
                    (project.value)
                      ? (_openBlock(), _createBlock(ProjectAddClientDropdown, {
                          key: 0,
                          "project-id": project.value.Id,
                          "added-clients": project.value.AttachedClients,
                          "show-close-icon": "",
                          onClose: closeAddClientDropdown
                        }, null, 8, ["project-id", "added-clients"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["mobile-title"]))
              : (_openBlock(), _createBlock(AppIcon, {
                  key: 1,
                  class: "project-page__direction-header-icon",
                  name: "plus",
                  width: "15px",
                  color: "#D2D2D2"
                })),
            _createElementVNode("div", _hoisted_26, _toDisplayString(_ctx.$t('clients_label')), 1),
            (_unref(isClientsOverflowing))
              ? (_openBlock(), _createBlock(AppTooltip, {
                  key: 2,
                  text: _ctx.$t('ui_fullscreen')
                }, {
                  activator: _withCtx(() => [
                    _createVNode(AppIcon, {
                      class: "project-page__direction-header-icon",
                      name: "arrow-expand",
                      width: "18px",
                      color: "#979797",
                      "hover-color": "#499259",
                      cursor: "pointer",
                      onClick: _cache[6] || (_cache[6] = ($event: any) => ($clientsModal.value?.onOpen()))
                    })
                  ]),
                  _: 1
                }, 8, ["text"]))
              : _createCommentVNode("", true)
          ])
        ]),
        (project.value?.AttachedClients && project.value.AttachedClients.length && _unref(projectStore).project?.AttachedClientsAccess!==0)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              ref_key: "$clientsBody",
              ref: $clientsBody,
              class: _normalizeClass({
					'project-page__direction-body': true,
					'project-page__direction-body--uc': true
				})
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(project.value.AttachedClients, (ac, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: ac.Id,
                  class: "project-page__direction-uc"
                }, [
                  _createElementVNode("div", _hoisted_27, [
                    _createElementVNode("div", _hoisted_28, _toDisplayString(index + 1) + ".", 1),
                    _createElementVNode("div", _hoisted_29, [
                      _createVNode(_component_router_link, {
                        class: "project-page__direction-uc-left-name-str",
                        to: { query: { page: 'client', id: ac.Id } }
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(ac.Name), 1)
                        ]),
                        _: 2
                      }, 1032, ["to"]),
                      (ac.Address)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_30, " (" + _toDisplayString(ac.Address) + ") ", 1))
                        : _createCommentVNode("", true),
                      (_unref(projectStore).project?.AttachedClientsAccess==2 && project.value.AttachedClients.length > 1)
                        ? (_openBlock(), _createBlock(AppTooltip, {
                            key: 1,
                            text: _ctx.$t('remove')
                          }, {
                            activator: _withCtx(() => [
                              _createVNode(AppIcon, {
                                class: "project-page__direction-uc-left-icon",
                                style: { marginTop: '-2px' },
                                name: "close-bold",
                                width: "12px",
                                color: "#D2D2D2",
                                "hover-color": "#BA4C4C",
                                cursor: "pointer",
                                onClick: ($event: any) => (onDetachClient(ac.Id))
                              }, null, 8, ["onClick"])
                            ]),
                            _: 2
                          }, 1032, ["text"]))
                        : _createCommentVNode("", true),
                      (_unref(projectStore).project?.AttachedClientsAccess==2)
                        ? (_openBlock(), _createBlock(AppResizableDropdown, {
                            key: 2,
                            position: "right",
                            "initial-width": 400,
                            "initial-height": 450,
                            "min-width": 400,
                            "max-width": 800,
                            "min-height": 450,
                            "max-height": 900,
                            "mobile-title": _ctx.$t('choose_roles'),
                            ref_for: true,
                            ref: (el) => { if (el) $addClientRoles.value[ac.Id] = el }
                          }, {
                            activator: _withCtx(() => [
                              _createVNode(AppTooltip, {
                                text: _ctx.$t('client_add_role')
                              }, {
                                activator: _withCtx(() => [
                                  _createVNode(AppIcon, {
                                    class: "project-page__direction-uc-left-icon",
                                    style: { marginTop: '-2px' },
                                    name: "hash",
                                    width: "18px",
                                    color: "#979797",
                                    "hover-color": "#499259",
                                    cursor: "pointer"
                                  })
                                ]),
                                _: 1
                              }, 8, ["text"])
                            ]),
                            default: _withCtx(() => [
                              (project.value)
                                ? (_openBlock(), _createBlock(ProjectAddRoleDropdown, {
                                    key: 0,
                                    "project-id": project.value.Id,
                                    "entity-id": ac.Id,
                                    "attached-roles": ac.Roles ?? [],
                                    target: "client",
                                    "show-close-icon": "",
                                    onClose: ($event: any) => (closeAddClientRoleDropdown(ac.Id))
                                  }, null, 8, ["project-id", "entity-id", "attached-roles", "onClose"]))
                                : _createCommentVNode("", true)
                            ]),
                            _: 2
                          }, 1032, ["mobile-title"]))
                        : _createCommentVNode("", true),
                      (ac.Roles?.length)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_31, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(ac.Roles, (role) => {
                              return (_openBlock(), _createElementBlock("span", {
                                key: role.Id,
                                class: "project-page__direction-uc-left-roles-item"
                              }, [
                                _createElementVNode("span", _hoisted_32, _toDisplayString(role.Name), 1),
                                (_unref(projectStore).project?.AttachedClientsAccess==2)
                                  ? (_openBlock(), _createBlock(AppTooltip, {
                                      key: 0,
                                      text: _ctx.$t('remove')
                                    }, {
                                      activator: _withCtx(() => [
                                        _createVNode(AppIcon, {
                                          class: "project-page__direction-uc-left-icon",
                                          style: { marginTop: '-2px' },
                                          name: "close-bold",
                                          width: "12px",
                                          color: "#D2D2D2",
                                          "hover-color": "#BA4C4C",
                                          cursor: "pointer",
                                          onClick: ($event: any) => (onDetachClientRole(ac.Id, role.Id))
                                        }, null, 8, ["onClick"])
                                      ]),
                                      _: 2
                                    }, 1032, ["text"]))
                                  : _createCommentVNode("", true)
                              ]))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]))
              }), 128))
            ], 512))
          : _createCommentVNode("", true)
      ]),
      _cache[13] || (_cache[13] = _createElementVNode("div", { class: "project-page__divider" }, null, -1)),
      _createElementVNode("div", _hoisted_33, [
        _createElementVNode("div", _hoisted_34, [
          _createElementVNode("div", _hoisted_35, [
            (_unref(projectStore).project?.AttackedWorkersAccess==2)
              ? (_openBlock(), _createBlock(AppResizableDropdown, {
                  key: 0,
                  position: "right",
                  resizable: "",
                  "initial-width": 400,
                  "initial-height": 450,
                  "min-width": 400,
                  "max-width": 800,
                  "min-height": 450,
                  "max-height": 900,
                  "mobile-title": _ctx.$t('choose_workers'),
                  ref_key: "$addWorker",
                  ref: $addWorker,
                  name: "$addWorker"
                }, {
                  activator: _withCtx(() => [
                    _createVNode(AppTooltip, {
                      text: _ctx.$t('ui_add')
                    }, {
                      activator: _withCtx(() => [
                        _createVNode(AppIcon, {
                          class: "project-page__direction-header-icon",
                          name: "plus",
                          width: "15px",
                          color: "#979797",
                          "hover-color": "#499259",
                          cursor: "pointer"
                        })
                      ]),
                      _: 1
                    }, 8, ["text"])
                  ]),
                  default: _withCtx(() => [
                    (project.value)
                      ? (_openBlock(), _createBlock(ProjectAddWorkerDropdown, {
                          key: 0,
                          "project-id": project.value.Id,
                          "added-workers": project.value.AttachedWorkers,
                          "show-close-icon": "",
                          onClose: closeAddWorkerDropdown
                        }, null, 8, ["project-id", "added-workers"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["mobile-title"]))
              : (_openBlock(), _createBlock(AppIcon, {
                  key: 1,
                  class: "project-page__direction-header-icon",
                  name: "plus",
                  width: "15px",
                  color: "#D2D2D2"
                })),
            _createElementVNode("div", _hoisted_36, _toDisplayString(_ctx.$t('client_workers')), 1)
          ])
        ]),
        (project.value?.AttachedWorkers && project.value.AttachedWorkers.length && _unref(projectStore).project?.AttackedWorkersAccess!==0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(project.value.AttachedWorkers, (aw, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: aw.Id,
                  class: "project-page__direction-aw"
                }, [
                  _createElementVNode("div", _hoisted_38, [
                    _createElementVNode("div", _hoisted_39, _toDisplayString(index + 1) + ".", 1),
                    _createElementVNode("div", {
                      class: _normalizeClass({
							'project-page__direction-aw-left-name': true,
							'project-page__direction-aw-left-name--removed': aw.Removed,
						})
                    }, [
                      _createTextVNode(_toDisplayString(aw.Name) + " ", 1),
                      (_unref(projectStore).project?.AttackedWorkersAccess==2)
                        ? (_openBlock(), _createBlock(AppTooltip, {
                            key: 0,
                            text: _ctx.$t('remove')
                          }, {
                            activator: _withCtx(() => [
                              _createVNode(AppIcon, {
                                class: "project-page__direction-aw-left-icon",
                                style: { marginTop: '-2px' },
                                name: "close-bold",
                                width: "12px",
                                color: "#D2D2D2",
                                "hover-color": "#BA4C4C",
                                cursor: "pointer",
                                onClick: ($event: any) => (onDetachWorker(aw.Id))
                              }, null, 8, ["onClick"])
                            ]),
                            _: 2
                          }, 1032, ["text"]))
                        : _createCommentVNode("", true),
                      (_unref(projectStore).project?.AttackedWorkersAccess==2)
                        ? (_openBlock(), _createBlock(AppResizableDropdown, {
                            key: 1,
                            position: "right",
                            "initial-width": 400,
                            "initial-height": 450,
                            "min-width": 400,
                            "max-width": 800,
                            "min-height": 450,
                            "max-height": 900,
                            "mobile-title": _ctx.$t('choose_roles'),
                            ref_for: true,
                            ref: (el) => { if (el) $addWorkerRoles.value[aw.Id] = el }
                          }, {
                            activator: _withCtx(() => [
                              _createVNode(AppTooltip, {
                                text: _ctx.$t('client_add_role')
                              }, {
                                activator: _withCtx(() => [
                                  _createVNode(AppIcon, {
                                    class: "project-page__direction-aw-left-icon",
                                    style: { marginTop: '-2px' },
                                    name: "hash",
                                    width: "18px",
                                    color: "#979797",
                                    "hover-color": "#499259",
                                    cursor: "pointer"
                                  })
                                ]),
                                _: 1
                              }, 8, ["text"])
                            ]),
                            default: _withCtx(() => [
                              (project.value)
                                ? (_openBlock(), _createBlock(ProjectAddRoleDropdown, {
                                    key: 0,
                                    "project-id": project.value.Id,
                                    "entity-id": aw.Id,
                                    "attached-roles": aw.Roles ?? [],
                                    target: "worker",
                                    "show-close-icon": "",
                                    onClose: ($event: any) => (closeAddWorkerRoleDropdown(aw.Id))
                                  }, null, 8, ["project-id", "entity-id", "attached-roles", "onClose"]))
                                : _createCommentVNode("", true)
                            ]),
                            _: 2
                          }, 1032, ["mobile-title"]))
                        : _createCommentVNode("", true),
                      (aw.Roles?.length)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_40, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(aw.Roles, (role) => {
                              return (_openBlock(), _createElementBlock("span", {
                                key: role.Id,
                                class: "project-page__direction-aw-left-roles-item"
                              }, [
                                _createElementVNode("span", _hoisted_41, _toDisplayString(role.Name), 1),
                                (_unref(projectStore).project?.AttackedWorkersAccess==2)
                                  ? (_openBlock(), _createBlock(AppTooltip, {
                                      key: 0,
                                      text: _ctx.$t('remove')
                                    }, {
                                      activator: _withCtx(() => [
                                        _createVNode(AppIcon, {
                                          class: "project-page__direction-aw-left-icon",
                                          style: { marginTop: '-2px' },
                                          name: "close-bold",
                                          width: "12px",
                                          color: "#D2D2D2",
                                          "hover-color": "#BA4C4C",
                                          cursor: "pointer",
                                          onClick: ($event: any) => (onDetachWorkerRole(aw.Id, role.Id))
                                        }, null, 8, ["onClick"])
                                      ]),
                                      _: 2
                                    }, 1032, ["text"]))
                                  : _createCommentVNode("", true)
                              ]))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true)
                    ], 2)
                  ])
                ]))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ]),
      _cache[14] || (_cache[14] = _createElementVNode("div", { class: "project-page__divider" }, null, -1)),
      (_unref(projectStore).project?.ParameterAccess==1 || _unref(projectStore).project?.ParameterAccess==2)
        ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
            _createElementVNode("div", _hoisted_43, [
              _createElementVNode("div", _hoisted_44, [
                (_unref(projectStore).project?.ParameterAccess==2)
                  ? (_openBlock(), _createBlock(AppTooltip, {
                      key: 0,
                      text: _ctx.$t('ui_add')
                    }, {
                      activator: _withCtx(() => [
                        _createElementVNode("span", {
                          ref_key: "parametersAddAnchor",
                          ref: parametersAddAnchor,
                          class: "project-page__direction-header-add-anchor",
                          onClick: _cache[7] || (_cache[7] = ($event: any) => (parametersAddOpen.value = true))
                        }, [
                          _createVNode(AppIcon, {
                            class: "project-page__direction-header-icon",
                            name: "plus",
                            width: "15px",
                            color: "#979797",
                            "hover-color": "#499259",
                            cursor: "pointer"
                          })
                        ], 512)
                      ]),
                      _: 1
                    }, 8, ["text"]))
                  : (_openBlock(), _createBlock(AppIcon, {
                      key: 1,
                      class: "project-page__direction-header-icon",
                      name: "plus",
                      width: "15px",
                      color: "#D2D2D2"
                    })),
                _createElementVNode("div", _hoisted_45, _toDisplayString(_ctx.$t('parameters_label')), 1)
              ])
            ]),
            (project.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                  _createVNode(ParametersSection, {
                    "entity-id": projectId.value,
                    "attachment-type": _unref(V2ParameterAttachmentType).Project,
                    "parameter-access": _unref(projectStore).project?.ParameterAccess,
                    "add-menu-target": parametersAddAnchor.value,
                    "add-menu-open": parametersAddOpen.value,
                    "onUpdate:addMenuOpen": _cache[8] || (_cache[8] = ($event: any) => ((parametersAddOpen).value = $event)),
                    onChanged: fetchProject
                  }, null, 8, ["entity-id", "attachment-type", "parameter-access", "add-menu-target", "add-menu-open"])
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      _cache[15] || (_cache[15] = _createElementVNode("div", { class: "project-page__divider" }, null, -1)),
      _createElementVNode("div", _hoisted_47, [
        (_unref(projectStore).project?.FileAccess==1 || _unref(projectStore).project?.FileAccess==2)
          ? (_openBlock(), _createBlock(FileBlock, {
              key: 0,
              id: projectId.value,
              "root-name": project.value?.Name,
              "rule-access": _unref(projectStore).project?.FileAccess
            }, null, 8, ["id", "root-name", "rule-access"]))
          : _createCommentVNode("", true)
      ]),
      _createVNode(ProjectInfoModal, {
        ref_key: "$projectInfoModal",
        ref: $projectInfoModal,
        title: _ctx.$t('project_information_and_access')
      }, null, 8, ["title"]),
      _createVNode(StageBusinessLogicModal, {
        ref_key: "$stageBusinessLogicModal",
        ref: $stageBusinessLogicModal
      }, null, 512),
      _createVNode(ProjectClientsExpandModal, {
        ref_key: "$clientsModal",
        ref: $clientsModal
      }, null, 512),
      _createVNode(ProjectFinanceExpandModal, {
        ref_key: "$financeModal",
        ref: $financeModal,
        onChanged: fetchProject
      }, null, 512)
    ], 512),
    (!isProjectLoading.value && _unref(projectStore).project?.FileAccess === 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
          _createElementVNode("div", _hoisted_49, [
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_50, [
                _createVNode(AppIcon, {
                  class: "project-page__direction-permition-icon",
                  name: "invalid",
                  width: "24px",
                  color: "#979797"
                }),
                _createElementVNode("div", _hoisted_51, _toDisplayString(_ctx.$t('project_files_no_access')), 1)
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})